import React from 'react';

import type { Dictionary } from 'lodash';
import { Tooltip, getFormattedTimeWindow, LayoutType, DateDisplayOption } from '@bringg/react-components';
import type { EtaResponseRouteItem } from '@bringg-frontend/eta-calculator';

import type { RoutesPlannerRun } from '../../../../../../types';
import { SECOND_IN_MS } from '../../../../../../utils/bringgTypesTransformers';
import { getHoursFormat } from '../../../../../../utils/date-utils';

interface Props {
	routeInfoByIndex: Dictionary<EtaResponseRouteItem>;
	routesById: Dictionary<RoutesPlannerRun>;
	runId: number;
	hourFormat: string;
	timeZone: string;
}

const RunTimesCell = ({ routeInfoByIndex, routesById, runId, hourFormat, timeZone }: Props) => {
	const runTimes = {
		depotEtl: routeInfoByIndex[runId]?.depot_etl || routesById[runId]?.depot_etl,
		depotBackEta: routeInfoByIndex[runId]?.depot_back_eta || routesById[runId]?.depot_back_eta
	};

	return (
		<div className="route-row-item run-times">
			{runTimes.depotEtl && runTimes.depotBackEta ? (
				<span className="route-row-item-run-times">
					<Tooltip
						title={getFormattedTimeWindow(
							new Date(runTimes.depotEtl * SECOND_IN_MS),
							new Date(runTimes.depotBackEta * SECOND_IN_MS),
							hourFormat,
							timeZone,
							LayoutType.INLINE,
							'',
							DateDisplayOption.SHOW_DATE_WHEN_DIFF_DAY
						)}
					>
						<div data-test-id="time-window">
							<span className="time-window-first-date" data-test-id="time-window-first-date">
								{getHoursFormat(runTimes.depotEtl * SECOND_IN_MS, timeZone, hourFormat)}
							</span>
							<span className="formatted-time-window-hyphen"> - </span>
							<span className="time-window-second-date" data-test-id="time-window-second-date">
								{getHoursFormat(runTimes.depotBackEta * SECOND_IN_MS, timeZone, hourFormat)}
							</span>
						</div>
					</Tooltip>
				</span>
			) : (
				'-'
			)}
		</div>
	);
};

export default RunTimesCell;
